import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapFilterEditPageComponent from './mapFilterEditPage.component';

let mapFilterEditPageModule = angular.module('mapFilterEditPage', [
  uiRouter
])

.component('mapFilterEditPage', mapFilterEditPageComponent)

.name;

export default mapFilterEditPageModule;
